import { useQuery } from "@tanstack/react-query"
import { FactoryGet } from "../app/models/Factory"
import { digitalManagerApi } from "../services/api"

export function useFactories() {
  const { data: factories = [], isLoading: isLoadingFactories } = useQuery({
    queryKey: ["factories"],
    queryFn: () => digitalManagerApi.get<FactoryGet[]>(`/factories`).then((r) => r.data),
  })

  return {
    factories,
    isLoadingFactories,
  }
}
